import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ServicesRoutingModule } from './services-routing.module';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import {
  UiModule,
  UtilsModule,
  FormStateService,
} from '@irembo-andela/irembogov3-common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule, FORMLY_CONFIG } from '@ngx-formly/core';
import { FieldWrapperComponent } from './service-configuration/field-wrapper/field-wrapper.component';
import { ConditionWrapperComponent } from './service-configuration/condition-wrapper/condition-wrapper.component';
import { FormlySwitchComponent } from './service-configuration/formly-switch/formly-switch.component';
import { FormlyRepeatComponent } from './service-configuration/formly-repeat/formly-repeat.component';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AlertWrapperComponent } from './service-configuration/alert-wrapper/alert-wrapper.component';
import { ManageServiceChangeRequestsComponent } from './manage-service-change-requests/manage-service-change-requests.component';
import { SettingsToolbarComponent } from './service-configuration/settings-toolbar/settings-toolbar.component';
import { FormTemplatesComponent } from './service-configuration/form-templates/form-templates.component';
import { RouterModule } from '@angular/router';
import { ServiceChangeRequestsListTableWidgetComponent } from './widgets/service-change-requests-list-table/service-change-requests-list-table.component';
import { ServiceChangeRequestStatusBadgeComponent } from './widgets/service-change-request-status-badge/service-change-request-status-badge.component';
import { ServiceChangeRequestTypeBadgeComponent } from './widgets/service-change-request-status-type/service-change-request-type-badge.component';
import { ConfigureServiceChangeRequestComponent } from './configure-service-change-request/configure-service-change-request.component';
import { ChangeRequestConfigurationHeaderWidgetComponent } from './widgets/change-request-configuration-header-widget/change-request-configuration-header-widget.component';
import { ServiceChangeRequestReviewerActionWidgetComponent } from './widgets/service-change-request-reviewer-action-widget/service-change-request-reviewer-action-widget.component';
import { ServiceChangeRequestConfigurerActionWidgetComponent } from './widgets/service-change-request-configurer-action-widget/service-change-request-configurer-action-widget.component';
import { ConfigurationMetadataOverviewFormComponent } from './configuration-steps/configuration-metadata-overview-form/configuration-metadata-overview-form.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { ConfigureServiceChangeRequestStepperComponent } from './widgets/configure-service-change-request-stepper/configure-service-change-request.stepper.component';
import { AngJsoneditorModule } from '@maaxgr/ang-jsoneditor';
import { IremboWorkflowBuilderV2Module } from './irembo-workflow-builder-v2/irembo-workflow-builder-v2.module';
import { ConfigurationWorkflowJsonEditorFormComponent } from './configuration-steps/configuration-workflow-json-editor-form/configuration-workflow-json-editor-form.component';
import { WorkflowTemplateSelectorListWidgetComponent } from './widgets/workflow-template-selector-list-widget/workflow-template-selector-list-widget.component';
import { ViewWorkflowTemplateDetailsWidgetComponent } from './widgets/view-workflow-template-details-widget/view-workflow-template-details-widget.component';
import { ConfigurationPricingFormComponent } from './configuration-steps/configuration-pricing-form/configuration-pricing-form.component';
import { PreviewServiceChangeRequestJsonFormdataWidgetComponent } from './widgets/preview-service-change-request-json-formdata-widget/preview-service-change-request-json-formdata-widget.component';
import { FormlyFieldStepperComponent } from '../../formly-components/formly-types/formly-field-stepper/formly-field-stepper.component';
import { FormlyFieldStepperSectionComponent } from '../../formly-components/formly-types/formly-field-stepper-section/formly-field-stepper-section.component';
import { FormlyFieldGroupComponent } from '../../formly-components/formly-types/formly-field-group/formly-field-group.component';
import { ConfigureServiceChangeRequestPriceHandlerComponent } from './widgets/configure-service-change-request-price-handler/configure-service-change-request-price-handler.component';
import { ConfigureServiceFixedPriceHandlerComponent } from './widgets/configure-service-fixed-price-handler/configure-service-fixed-price-handler.component';
import { ReviewServiceChangeRequestComponent } from './review-service-change-request/review-service-change-request.component';
import { ViewServiceChangeRequestComponent } from './view-service-change-request/view-service-change-request.component';
import { ServiceChangeRequestViewerActionWidgetComponent } from './widgets/service-change-request-viewer-action-widget/service-change-request-viewer-action-widget.component';
import { ReviewMetadataOverviewComponent } from './review-steps/review-metadata-overview/review-metadata-overview.component';
import { ReviewerIssuesEntryFormWidgetWidgetComponent } from './widgets/reviewer-issues-entry-form-widget/reviewer-issues-entry-form-widget.component';
import { ReviewFormbuilderJsonEditorComponent } from './review-steps/review-formbuilder-json-editor/review-formbuilder-json-editor.component';
import { ReviewSubmissionComponent } from './review-steps/review-submission/review-submission.component';
import { ConfigureServiceDynamicPriceHandlerComponent } from './widgets/configure-service-dynamic-price-handler/configure-service-dynamic-price-handler.component';
import { ConfigureServiceDynamicPricingFormComponent } from './widgets/configure-service-dynamic-pricing-form/configure-service-dynamic-pricing-form.component';
import { ChangeRequestStatusToLabelPipe } from '../../core/pipes/change-request-status-to-label.pipe';
import { ReviewIssueStatusToLabelPipe } from '../../core/pipes/review-issue-status-to-label.pipe';
import { ReviewSectionToLabelPipe } from '../../core/pipes/review-section-to-label.pipe';
import { ReviewWorkflowJsonEntryComponent } from './review-steps/review-workflow-json-entry/review-workflow-json-entry.component';
import { ReviewPricingComponent } from './review-steps/review-pricing/review-pricing.component';
import { ServiceRequestItemPricingWidgetComponent } from './widgets/service-request-item-pricing-widget/service-request-item-pricing-widget.component';
import { RequestPricingDynamicOperatorToLabel } from '../../core/pipes/request-pricing-dynamic-operator-to-label.pipe';
import { ReviewIssueCreatedDatePipe } from '../../core/pipes/review-issue-created-date.pipe';
import { ReviewerIssueStatusBadgeWidgetComponent } from './widgets/reviewer-issue-status-badge-widget/reviewer-issue-status-badge-widget.component';
import { ConfigurationFormBuilderComponent } from './configuration-steps/configuration-form-builder/configuration-form-builder.component';
import { ReviewerIssuesListWidgetComponent } from './widgets/reviewer-issues-list-widget/reviewer-issues-list-widget.component';

import { ServiceChangeRequestFeedbackHandlerWidgetComponent } from './widgets/service-change-request-feedback-handler-widget/service-change-request-feedback-handler-widget.component';
import { ReviewIssuesEditFormWidgetComponent } from './widgets/review-issues-edit-form-widget/review-issues-edit-form-widget.component';
import { FormFieldConfiguratorSettingsComponent } from './form-field-configurator/form-field-configurator-settings/form-field-configurator-settings.component';
import { FormFieldConfiguratorComponent } from './form-field-configurator/form-field-configurator.component';
import { FieldConfigTypeAsStringPipe } from '../../core/pipes/field-config-type-as-string.pipe';
import { FormFieldTypesListComponent } from './form-field-configurator/form-field-types-list/form-field-types-list.component';
import { TranslationServiceOverviewComponent } from './configuration-steps/configuration-translation/widgets/translation-service-overview/translation-service-overview.component';
import { ConfigurationTranslationComponent } from './configuration-steps/configuration-translation/configuration-translation.component';
import { ReviewTranslationsComponent } from './review-steps/review-translations/review-translations.component';
import { PanelWrapperComponent } from './service-configuration/panel-wrapper/panel-wrapper.component';
import { FormFieldWidgetsListComponent } from './form-field-configurator/form-field-widgets-list/form-field-widgets-list.component';
import { QuillModule } from 'ngx-quill';
import { ConfigurationOfficerFormComponent } from './configuration-steps/configuration-officer-form/configuration-officer-form.component';
import { OfficerFormPreviewJsonFormdataWidgetComponent } from './configuration-steps/configuration-officer-form/widgets/officer-form-preview-json-formdata-widget/officer-form-preview-json-formdata-widget.component';
import { TagInputModule } from 'ngx-chips';
import { HiddenHideFieldsPlaceholderComponent } from './service-configuration/hidden-hide-fields-placeholder/hidden-hide-fields-placeholder.component';
import { WorkflowEditorComponent } from './irembo-workflow-editor/state-machine-preview/state-machine-preview.component';
import { StateMachineComponent } from './irembo-workflow-editor/workflow/state-machine.component';
import { WorkflowTransitionComponent } from './irembo-workflow-editor/workflow/transition/transition.component';
import { WorkflowStateComponent } from './irembo-workflow-editor/workflow/state/state.component';
import { EditTransitionComponent } from './irembo-workflow-editor/edit-transition/edit-transition.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FullscreenDirective } from './irembo-workflow-editor/directive/fullscreen.directive';
import { DeleteConfirmationModalComponent } from './irembo-workflow-editor/confirmation-modal/confirmation-modal.component';
import { CustomRichEditorComponent } from './irembo-workflow-editor/custom-rich-editor/custom-rich-editor.component';

import { formlyConfigFactory } from '../../core/config/formly-config.factory';
import { IrembogovCertificateListComponent } from './widgets/irembogov-certificate-list/irembogov-certificate-list.component';
import { IrembogovFormlyAttachmentComponent } from './widgets/irembogov-formly-attachment/irembogov-formly-attachment.component';
import { WorkflowConfigFormsModule } from './workflow-config-forms.module';
import { ConfigureServicePriceLogicHandlerComponent } from './widgets/configure-service-price-logic-handler/configure-service-price-logic-handler.component';
import { ToggleButtonComponent } from '../../components/toggle-button/toggle-button.component';
import { PaginationComponent } from '../../components/pagination/pagination.component';
import { ConfigureRemindersComponent } from './widgets/configure-reminders/configure-reminders.component';
import { JourneysComponent } from './service-configuration/journey-configuration/journeys/journeys.component';
import { JourneyV3ConfigComponent } from './service-configuration/journey-configuration/journey-v3-config/journey-v3-config.component';
import { CustomMultiselectCheckboxComponent } from './service-configuration/custom-multiselect-checkbox/custom-multiselect-checkbox.component';
import { CustomServiceSelectorComponent } from '../../formly-components/formly-types/custom-service-selector/custom-service-selector.component';
import { PaginatedTemplateDropdownComponent } from '../../formly-components/formly-types/paginated-template-dropdown/paginated-template-dropdown.component';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { ServiceTemplatesComponent } from './service-templates/service-templates.component';
import { ServiceTemplateStatusBadgeComponent } from './service-templates/service-template-status-badge/service-template-status-badge.component';
import { TemplateSelectionComponent } from './service-templates/template-selection/template-selection.component';
import { TemplatePreviewComponent } from './service-templates/template-preview/template-preview.component';
import { CreateTemplateComponent } from './service-templates/create-template/create-template.component';
import { EditTemplateComponent } from './service-templates/edit-template/edit-template.component';
import { ConvertExistingServiceComponent } from './service-templates/convert-existing-service/convert-existing-service.component';
import { DeleteConfirmationModalComponent as TemplateDeleteConfirmationModalComponent } from './widgets/delete-confirmation-modal/delete-confirmation-modal.component';
import { PublishConfirmationModalComponent } from './widgets/publish-confirmation-modal/publish-confirmation-modal.component';
import { UnpublishConfirmationModalComponent } from './widgets/unpublish-confirmation-modal/unpublish-confirmation-modal.component';
import { TemplateConfigurationHeaderWidgetComponent } from './widgets/template-configuration-header-widget/template-configuration-header-widget.component';
import { TemplateConfigurationStepperComponent } from './widgets/template-configuration-stepper/template-configuration-stepper.component';
import { UseTemplateConfirmationModalComponent } from './widgets/use-template-confirmation-modal/use-template-confirmation-modal.component';
import { TemplatePreviewPricingComponent } from './service-templates/service-template-preview-pricing/template-preview-pricing.component';
import { FormlyFieldHtmlEditorComponent } from '../../formly-components/formly-types/formly-field-html-editor/formly-field-html-editor.component';
import { ServiceValidationRuleWrapperComponent } from './service-configuration/service-validation-rule-wrapper/service-validation-rule-wrapper.component';
import { ConfigurationRestrictionsComponent } from './configuration-steps/configuration-restrictions/configuration-restrictions.component';
import { ReplaceCommentConfirmModalComponent } from './widgets/replace-comment-confirm-modal/replace-comment-confirm-modal.component';
import { FormBuilderV2Module } from '../form-builder-v2/form-builder-v2.module';

@NgModule({
  declarations: [
    ManageServiceChangeRequestsComponent,
    ServiceChangeRequestsListTableWidgetComponent,
    FieldWrapperComponent,
    PanelWrapperComponent,
    SettingsToolbarComponent,
    HiddenHideFieldsPlaceholderComponent,
    FormTemplatesComponent,
    FormlySwitchComponent,
    FormlyRepeatComponent,
    AlertWrapperComponent,
    ConditionWrapperComponent,
    ServiceChangeRequestStatusBadgeComponent,
    ServiceChangeRequestTypeBadgeComponent,
    ConfigureServiceChangeRequestComponent,
    ChangeRequestConfigurationHeaderWidgetComponent,
    ServiceChangeRequestReviewerActionWidgetComponent,
    ServiceChangeRequestConfigurerActionWidgetComponent,
    ConfigurationMetadataOverviewFormComponent,
    ConfigureServiceChangeRequestStepperComponent,
    ConfigurationWorkflowJsonEditorFormComponent,
    ConfigurationFormBuilderComponent,
    WorkflowTemplateSelectorListWidgetComponent,
    ViewWorkflowTemplateDetailsWidgetComponent,
    ConfigurationPricingFormComponent,
    PreviewServiceChangeRequestJsonFormdataWidgetComponent,
    FormlyFieldStepperComponent,
    FormlyFieldStepperSectionComponent,
    FormlyFieldGroupComponent,
    ConfigurationPricingFormComponent,
    ConfigureServiceChangeRequestPriceHandlerComponent,
    ConfigureServiceFixedPriceHandlerComponent,
    ReviewServiceChangeRequestComponent,
    ViewServiceChangeRequestComponent,
    ServiceChangeRequestViewerActionWidgetComponent,
    ReviewMetadataOverviewComponent,
    ReviewerIssuesEntryFormWidgetWidgetComponent,
    ReviewFormbuilderJsonEditorComponent,
    ReviewSubmissionComponent,
    ConfigureServiceDynamicPriceHandlerComponent,
    ConfigureServiceDynamicPricingFormComponent,
    ConfigureServicePriceLogicHandlerComponent,
    ChangeRequestStatusToLabelPipe,
    ReviewIssueStatusToLabelPipe,
    ReviewSectionToLabelPipe,
    ReviewWorkflowJsonEntryComponent,
    ReviewPricingComponent,
    ServiceRequestItemPricingWidgetComponent,
    RequestPricingDynamicOperatorToLabel,
    ReviewIssueCreatedDatePipe,
    FieldConfigTypeAsStringPipe,
    ReviewerIssueStatusBadgeWidgetComponent,
    ReviewerIssuesListWidgetComponent,
    ServiceChangeRequestFeedbackHandlerWidgetComponent,
    ReviewIssuesEditFormWidgetComponent,
    FormFieldConfiguratorComponent,
    FormFieldConfiguratorSettingsComponent,
    FormFieldTypesListComponent,
    ConfigurationTranslationComponent,
    TranslationServiceOverviewComponent,
    ReviewTranslationsComponent,
    FormFieldWidgetsListComponent,
    ConfigurationOfficerFormComponent,
    OfficerFormPreviewJsonFormdataWidgetComponent,
    WorkflowEditorComponent,
    StateMachineComponent,
    WorkflowTransitionComponent,
    WorkflowStateComponent,
    EditTransitionComponent,
    FullscreenDirective,
    DeleteConfirmationModalComponent,
    CustomRichEditorComponent,
    IrembogovCertificateListComponent,
    IrembogovFormlyAttachmentComponent,
    ToggleButtonComponent,
    PaginationComponent,
    ConfigureRemindersComponent,
    JourneysComponent,
    JourneyV3ConfigComponent,
    CustomMultiselectCheckboxComponent,
    CustomServiceSelectorComponent,
    PaginatedTemplateDropdownComponent,
    ServiceTemplatesComponent,
    ServiceTemplateStatusBadgeComponent,
    TemplateSelectionComponent,
    TemplatePreviewComponent,
    CreateTemplateComponent,
    EditTemplateComponent,
    ConvertExistingServiceComponent,
    TemplateDeleteConfirmationModalComponent,
    PublishConfirmationModalComponent,
    UnpublishConfirmationModalComponent,
    TemplateConfigurationHeaderWidgetComponent,
    TemplateConfigurationStepperComponent,
    UseTemplateConfirmationModalComponent,
    TemplatePreviewPricingComponent,
    FormlyFieldHtmlEditorComponent,
    ServiceValidationRuleWrapperComponent,
    ConfigurationRestrictionsComponent,
    ReplaceCommentConfirmModalComponent,
  ],
  imports: [
    CommonModule,
    ServicesRoutingModule,
    WorkflowConfigFormsModule,
    IremboWorkflowBuilderV2Module,
    FormBuilderV2Module,
    UiModule,
    UtilsModule,
    NgbModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CdkStepperModule,
    AngJsoneditorModule,
    MatExpansionModule,
    QuillModule.forRoot(),
    FormlyModule.forRoot(),
    FormlyBootstrapModule,
    DragDropModule,
    TagInputModule,
    MonacoEditorModule.forRoot(),
    NgbNavModule,
  ],
  providers: [
    DatePipe,
    FormStateService,
    {
      provide: FORMLY_CONFIG,
      multi: true,
      useFactory: formlyConfigFactory,
      deps: [FormStateService],
    },
  ],
})
export class ServicesModule {}
